/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hospitationchancenwerkids4Inputs */

const de__field_hospitationchancenwerkids4 = /** @type {(inputs: _Field_Hospitationchancenwerkids4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hospitierende Chancen WerkIDs`)
};

/**

* @param {_Field_Hospitationchancenwerkids4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_hospitationchancenwerkids4 = /** @type {((inputs?: _Field_Hospitationchancenwerkids4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hospitationchancenwerkids4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_hospitationchancenwerkids4(inputs)
});
export { _field_hospitationchancenwerkids4 as "_field_hospitationChancenWerkIDs" }